import React from "react"
import { navigate } from "gatsby"
import Styles from "./UserMenu.module.scss"
import { connect } from "react-redux"
import { startLogin, startLogout } from "../../../../actions/auth"
import AccountIcon from "../../../Icons/Generic/user"
import ShippingIcon from "../../../Icons/Generic/shipping"
import ListIcon from "../../../Icons/Generic/list"
import ExitIcon from "../../../Icons/Generic/exit"
import GoogleLogo from "../../../Icons/Social/google"
import FacebookLogo from "../../../Icons/Social/Facebook"
import { closeUserMenu } from "../../../../actions/userMenu"
import { dashboardOpeningState } from "../../../../actions/userMenu"
import { resetState } from "../../../../actions/auth"

const UserMenu = ({
  userLoggedIn,
  closeUserMenu,
  dashboardOpeningState,
  startLogin,
  startLogout,
  loginError,
  loginErrorMessage,
  resetState,
}) => {
  const userMenuClick = (link, openingState) => {
    //dashboard is one single page with various component display states
    closeUserMenu()
    navigate(link)
    switch (openingState) {
      case "account":
        return dashboardOpeningState("account")
      case "orders":
        return dashboardOpeningState("orders")
      case "savedlists":
        return dashboardOpeningState("savedlists")
      default:
        break
    }
  }

  const renderSwitch = userLoggedIn => {
    switch (userLoggedIn) {
      case true:
        return (
          <ul className={Styles.authorisedmenu}>
            <li onClick={() => userMenuClick("/user/dashboard", "account")}>
              <AccountIcon /> My Account
            </li>
            <li onClick={() => userMenuClick("/user/dashboard", "orders")}>
              <ShippingIcon /> My Orders
            </li>
            <li onClick={() => userMenuClick("/user/dashboard", "savedlists")}>
              <ListIcon /> My Saved List
            </li>
            <li
              onClick={() => {
                userMenuClick("/", "")
                startLogout()
                resetState()
              }}
            >
              <ExitIcon />
              Sign Out
            </li>
          </ul>
        )
      case false:
        return (
          <ul className={Styles.unauthorisedmenu}>
            <li
              className={Styles.googlelogin}
              onClick={() => {
                startLogin("google")
              }}
            >
              <GoogleLogo />
              Sign In With Google
            </li>
            <li
              className={Styles.facebooklogin}
              onClick={() => {
                startLogin("facebook")
              }}
            >
              <FacebookLogo />
              Sign In With Facebook
            </li>
            {loginErrorMessage ? (
              <li className={Styles.errormessage}>{loginErrorMessage}</li>
            ) : null}
          </ul>
        )
      default:
        return null
    }
  }

  return <div className={Styles.usermenu}>{renderSwitch(userLoggedIn)}</div>
}

const mapDispatchToProps = dispatch => ({
  dashboardOpeningState: openingState =>
    dispatch(dashboardOpeningState(openingState)),
  closeUserMenu: () => dispatch(closeUserMenu()),
  startLogout: () => dispatch(startLogout()),
  startLogin: provider => dispatch(startLogin(provider)),
  resetState: () => dispatch(resetState())
})

const mapStateToProps = state => {
  return {
    userLoggedIn: state.auth.uid ? true : false, // if a uid exists user is logged in
    loginError: state.auth.errorCode ? state.auth.errorCode : false,
    loginErrorMessage: state.auth.errorMessage ? state.auth.errorMessage : "",
  }
}

// calls to connect
export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)
